import React, {
  useMemo,
  useState,
} from 'react';

import InvoiceDocument from './InvoiceDocument.jsx';

import './InvoiceIdentifyParties.css';


const InvoiceIdentifyParties = ({
  content,
  invoice,
}) => {
  const [selectedAnswer, setSelectedAnswer] =
    useState('');

  const [isChecked, setIsChecked] =
    useState(false);


  /* =====================================================
     DATE FACTURA
  ===================================================== */

  const invoiceData =
    invoice ||
    content?.invoice ||
    null;


  /* =====================================================
     INTREBARE
  ===================================================== */

  const question =
    content?.question ||
    'Identifica rolul firmei in aceasta operatiune.';


  const options =
    Array.isArray(
      content?.options
    )
      ? content.options
      : [];


  const correctAnswer =
    content?.correctAnswer;


  const explanation =
    content?.explanation;


  /* =====================================================
     STARE RASPUNS
  ===================================================== */

  const isCorrect =
    useMemo(() => {
      if (
        !isChecked ||
        !selectedAnswer
      ) {
        return false;
      }

      return (
        selectedAnswer ===
        correctAnswer
      );
    }, [
      isChecked,
      selectedAnswer,
      correctAnswer,
    ]);


  /* =====================================================
     SELECTARE
  ===================================================== */

  const handleSelect = (
    option
  ) => {
    if (isChecked) {
      return;
    }

    setSelectedAnswer(
      option
    );
  };


  /* =====================================================
     VERIFICARE
  ===================================================== */

  const handleCheck = () => {
    if (!selectedAnswer) {
      return;
    }

    setIsChecked(true);
  };


  /* =====================================================
     RESET
  ===================================================== */

  const handleReset = () => {
    setSelectedAnswer('');
    setIsChecked(false);
  };


  /* =====================================================
     CLASS OPTION
  ===================================================== */

  const getOptionClassName = (
    option
  ) => {
    const classes = [
      'invoice-identify-option',
    ];


    if (
      !isChecked &&
      selectedAnswer === option
    ) {
      classes.push(
        'is-selected'
      );
    }


    if (isChecked) {
      if (
        option ===
        correctAnswer
      ) {
        classes.push(
          'is-correct'
        );
      } else if (
        option ===
        selectedAnswer
      ) {
        classes.push(
          'is-incorrect'
        );
      }
    }


    return classes.join(' ');
  };


  /* =====================================================
     PROTECTIE
  ===================================================== */

  if (!content) {
    return null;
  }


  return (
    <div className="invoice-identify-parties">


      {/* =================================================
          FACTURA
      ================================================= */}

      {invoiceData && (
        <div className="invoice-identify-document">

          <InvoiceDocument
            invoice={
              invoiceData
            }
          />

        </div>
      )}


      {/* =================================================
          QUIZ
      ================================================= */}

      <div className="invoice-identify-quiz">


        <span className="invoice-identify-eyebrow">
          IDENTIFICA PARTILE
        </span>


        <h2>
          {question}
        </h2>


        {content.context && (
          <p className="invoice-identify-context">
            {content.context}
          </p>
        )}


        {/* ===============================================
            OPTIUNI
        =============================================== */}

        <div className="invoice-identify-options">

          {options.map(
            (
              option,
              index
            ) => (
              <button
                key={
                  `${option}-${index}`
                }
                type="button"
                className={
                  getOptionClassName(
                    option
                  )
                }
                onClick={() =>
                  handleSelect(
                    option
                  )
                }
                disabled={
                  isChecked
                }
              >

                <span className="invoice-identify-option-letter">
                  {
                    String.fromCharCode(
                      65 + index
                    )
                  }
                </span>

                <span>
                  {option}
                </span>

              </button>
            )
          )}

        </div>


        {/* ===============================================
            FEEDBACK
        =============================================== */}

        {isChecked && (
          <div
            className={[
              'invoice-identify-feedback',
              isCorrect
                ? 'is-correct'
                : 'is-incorrect',
            ]
              .filter(Boolean)
              .join(' ')}
          >

            <strong>
              {
                isCorrect
                  ? 'Corect!'
                  : 'Mai verifica o data.'
              }
            </strong>


            {explanation && (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    explanation,
                }}
              />
            )}

          </div>
        )}


        {/* ===============================================
            ACTIUNI
        =============================================== */}

        <div className="invoice-identify-actions">

          {!isChecked ? (
            <button
              type="button"
              className="invoice-identify-check"
              onClick={
                handleCheck
              }
              disabled={
                !selectedAnswer
              }
            >
              Verifica
            </button>
          ) : (
            <button
              type="button"
              className="invoice-identify-reset"
              onClick={
                handleReset
              }
            >
              Incearca din nou
            </button>
          )}

        </div>

      </div>

    </div>
  );
};


export default InvoiceIdentifyParties;